import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type CreateQuoteComparisonViewPayload = {
  primaryCriteria: string;
  selectedCriteria: string;
  quote1Id: string | null;
  quote2Id: string | null;
  quote3Id: string | null;
  quote4Id: string | null;
  quote5Id: string | null;
};

export const createQuoteComparisonView = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: CreateQuoteComparisonViewPayload
    ): Promise<string> => {
      return fetchWithAuth<string>(
        "createDossierQuoteComparisonView",
        dossierId,
        {
          requestOptions: {
            method: "post",
            body: JSON.stringify(payload),
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
